import React, { useRef } from 'react';
import { parseHtml } from './util';
import { prevewImage } from '@components/PrevewImage';
import { previewVideo } from '@element/Video/preview';
// import { useIsomorphicLayoutEffect } from '@lib/hooks';
import styles from './index.module.less';

export const PostContent = (props) => {
  const { html } = props;
  const { htmlText, imgSrcGroup } = parseHtml(html)
  const imgSrcGroupRef = useRef(imgSrcGroup);
  const onClick = (e) => {
    if (e.target.tagName === 'IMG') {
      prevewImage({ src: e.target.src, imgGroup: imgSrcGroupRef.current });
    }
    if (e.target.tagName === 'VIDEO') {
      previewVideo({ videoSource: e.target.currentSrc });
    }
  };
  return (
    <div
      onClick={onClick}
      className={styles.container}
      dangerouslySetInnerHTML={{ __html: htmlText }}
    ></div>
  );
};
